export const BYTES_PER_MB = 1024 * 1024
export const BYTES_PER_GB = 1024 * 1024 * 1024

export const bytesToMegabytes = (bytes: number) => Math.round(bytes / BYTES_PER_MB)
export const bytesToGigabytes = (bytes: number) => Math.round(bytes / BYTES_PER_GB)
